import { liveInProgressLabel, timelineInProgressVerb } from './timelineLiveLabel'
import { timelineRunStartedAt } from './timelineRunStartedAt'

export function streamingTimelineDuration({
  publicActivity,
  activity,
  publicView,
  now,
  thoughtSummary,
  hasResponseText,
  clientRunStartedAt,
}) {
  const hasActivity =
    activity.length > 0 || publicView.phases.some((phase) => phase.rows.length > 0)
  const verb = timelineInProgressVerb({ hasResponseText, thoughtSummary, hasActivity })
  if (verb === 'Thinking') return 'Thinking'
  const startedAt =
    clientRunStartedAt ?? timelineRunStartedAt({ publicActivity, activity })
  return liveInProgressLabel(startedAt, now, verb)
}
